export enum images_work {
  banner_work = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_work.webp/beautify",
  banner_work_mobile = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_work_mobile.webp/beautify",
}
